import { normalizeGiphyRating } from './giphy';

export const DEFAULT_BOARD_GIF_SETTINGS = {
  boardsEnabled: true,
  boardDefaultRating: 'pg',
};

export const DEFAULT_BOARD_OVERRIDE = {
  mode: 'inherit',
  rating: 'pg',
};

export function normalizeTeamBoardGifSettings(value = {}) {
  return {
    boardsEnabled: value?.boardsEnabled !== false,
    boardDefaultRating: normalizeGiphyRating(value?.boardDefaultRating, DEFAULT_BOARD_GIF_SETTINGS.boardDefaultRating),
  };
}

export function normalizeBoardGifSettings(value = {}) {
  const mode = ['inherit', 'disabled', 'custom'].includes(value?.mode) ? value.mode : 'inherit';
  return {
    mode,
    rating: normalizeGiphyRating(value?.rating, DEFAULT_BOARD_OVERRIDE.rating),
  };
}

export function resolveBoardGifPolicy({ teamGifSettings = {}, boardGifSettings = {} } = {}) {
  const team = normalizeTeamBoardGifSettings(teamGifSettings);
  const board = normalizeBoardGifSettings(boardGifSettings);
  if (board.mode === 'disabled') return { enabled: false, rating: team.boardDefaultRating, source: 'board' };
  if (board.mode === 'custom') return { enabled: true, rating: board.rating, source: 'board' };
  return { enabled: team.boardsEnabled, rating: team.boardDefaultRating, source: 'team' };
}
